import React from 'react';
import {
  TextField,
  Box
} from '@mui/material';
import { PopupDialog } from '../../../../components/common';
import { useModeloForm } from '../hooks/useModeloForm';
import { useMarcaStore } from '../store';

interface Props {
  open: boolean;
  modeloId: number | null;
  onClose: () => void;
}

export const ModeloEditDialog: React.FC<Props> = ({
  open,
  modeloId,
  onClose
}) => {
  const { selectedMarca, saveModelo } = useMarcaStore();

  const {
    formData,
    errors,
    loading,
    isValid,
    handleChange,
    handleSubmit,
    resetForm
  } = useModeloForm(modeloId, selectedMarca?.idMarca || 0, saveModelo);

  const handleSave = async () => {
    try {
      await handleSubmit();
      onClose();
      resetForm();
    } catch {
      // Error handling is done in the hook and store
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
      resetForm();
    }
  };

  if (!selectedMarca && !modeloId) {
    return null;
  }

  return (
    <PopupDialog
      open={open}
      onClose={handleClose}
      title={modeloId ? 'Editar Modelo' : 'Nuevo Modelo'}
      maxWidth="sm"
      primaryAction={{
        label: loading ? 'Guardando...' : 'Guardar',
        onClick: handleSave,
        disabled: loading || !isValid,
        loading: loading
      }}
      secondaryAction={{
        label: 'Cancelar',
        onClick: handleClose,
        disabled: loading
      }}
    >
      <Box sx={{ pt: 1 }}>
        <TextField
          fullWidth
          label="Marca"
          value={selectedMarca?.descripcion || ''}
          disabled
          sx={{ mb: 2 }}
        />
        <TextField
          autoFocus
          fullWidth
          label="Descripción"
          name="descripcion"
          value={formData.descripcion}
          onChange={handleChange}
          error={!!errors.descripcion}
          helperText={errors.descripcion}
          disabled={loading}
        />
      </Box>
    </PopupDialog>
  );
};